import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { AuthManagerService } from '../../shared-api/auth/auth-manager.service';

@Injectable({
    providedIn: 'root'
})
export class LoginGuardService 
{
    constructor(private router: Router,
                private authManager: AuthManagerService) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
        return this.checkLogin(state.url);
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot)
    {
        return this.canActivate(route, state);
    }

    private checkLogin(url: string): boolean
    {
        if (!this.authManager.authenticatedUser || !this.authManager.authenticatedUser.isLoggedIn()) {
            this.router.navigate(['/account/sign-in']);
            return false;
        }

        return true;
    }
}
